module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/karolina-dolecka-6b10b9414d18eeee44bdad0d588f71f1.png";